import { Card, CardContent, Typography, styled, Box, Avatar, Chip } from '@mui/material';
import { Author } from '../../api/authorService';

const AuthorCardContainer = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.3s, box-shadow 0.3s',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: theme.shadows[6],
  },
  background: 'linear-gradient(145deg, #1a0933 0%, #0f051d 100%)',
  border: '1px solid rgba(110, 59, 255, 0.3)',
}));

const AuthorName = styled(Typography)({
  background: 'linear-gradient(90deg, #6e3bff, #ff3bff)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 700,
  fontSize: '1.25rem',
});

export const AuthorCard = ({ author }: { author: Author }) => {
  return (
    <AuthorCardContainer>
      <CardContent sx={{ flexGrow: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
          <Avatar 
            src={`https://ui-avatars.com/api/?name=${author.username}&background=6e3bff&color=fff`}
            sx={{ 
              width: 80, 
              height: 80,
              mb: 2,
              border: '2px solid #6e3bff'
            }}
          />
          <Box sx={{ textAlign: 'center' }}>
            <AuthorName variant="h6">
              @{author.username}
              {author.verified && (
                <span style={{ color: '#1DA1F2', marginLeft: 4 }}>✓</span>
              )}
            </AuthorName>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              Подписчики
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              {author.followers?.toLocaleString() || 'N/A'}
            </Typography>
          </Box>
          
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              Видео
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              {author.video_count}
            </Typography>
          </Box>
        </Box>

        {author.verified && (
          <Chip 
            label="Проверен" 
            size="small" 
            color="success"
            sx={{ mt: 2, alignSelf: 'center' }}
          />
        )}
      </CardContent>
    </AuthorCardContainer>
  );
};